export const TEST_VPN_CONFIG = `[Interface]
PrivateKey = wAGh5qJpfTxSfj8Th1nFTPfjuF17xlb0C+Gu3sNw7nw=
Address = 10.0.100.13/24
DNS = 192.168.2.20, 192.168.2.21, 8.8.8.8, 8.8.4.4

[Peer]
PublicKey = Lw0Qe7Re8WuPuje6KkzSq4jXugfV+uIgk45d+drYtGM=
AllowedIPs = 192.168.2.0/24, 10.0.0.0/8
Endpoint = 209.41.78.125:51820
PersistentKeepalive = 25`;